{
  "version": 1,
  "asset_id": "139bd5c8-83f7-4a36-acd5-674ffc4c43ec",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/139bd5c8-83f7-4a36-acd5-674ffc4c43ec/loc-plano-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/139bd5c8-83f7-4a36-acd5-674ffc4c43ec/loc-plano-640.webp",
  "original_filename": "loc-plano-640.webp",
  "size": 26670,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:31Z"
}
